import { IconProps, Step, StepContent, StepLabel, Stepper } from "@mui/material";
import React from "react";

export default function TimeLineStepper({
    Icon,
    Itens,
    iconProps = {
        fontSize: "medium",
        color: "primary",
        sx: { display: "flex", alignItems: "center", justifyContent: "center" }
    },
    dinamicIcon,
    dinamicIconProps
}: TimeLineStepperProps) {
    return (
        <Stepper orientation="vertical" nonLinear>
            {Itens.map((item, index) => (
                <Step key={index} active={true}>
                    <StepLabel
                        icon={
                            dinamicIcon
                                ? React.createElement(dinamicIcon(index), dinamicIconProps ? dinamicIconProps(index) : iconProps)
                                : <Icon {...(dinamicIconProps ? dinamicIconProps(index) : {...iconProps})}  />
                        }
                    >
                        {item.itensLabel}
                    </StepLabel>
                    <StepContent>{item.itensContent}</StepContent>
                </Step>
            ))}
        </Stepper>
    );
}

export interface TimeLineStepperProps {
    Itens: Array<{
        itensLabel: React.ReactNode;
        itensContent: React.ReactNode;
    }>;
    Icon: React.ElementType;
    iconProps?: IconProps;
    dinamicIcon?: (index: number) => React.ElementType;
    dinamicIconProps?: (index: number) => IconProps;
}